import { Point } from '@visx/point';
export default function createPoint(_ref, horizontal) {
  let {
    x,
    y
  } = _ref;
  return new Point(horizontal ? {
    x,
    y
  } : {
    x: y,
    y: x
  });
}